export const RESPONSIBLE_AREA_STYLES = {
    customer: 'bg-yellow-100 text-yellow-800',
    // Distinct from lastmile. Both owners used to carry the same orange, which made two of
    // the four indistinguishable at a glance — and the chip is the operator's whole answer
    // to "who resolves this".
    cubbo_ops: 'bg-teal-100 text-teal-800',
    lastmile: 'bg-orange-100 text-orange-800',
    tech: 'bg-red-100 text-red-800',
    // Fiscal problems belong to their own area: a missing or rejected NF-e is
    // resolved by Fiscal, not by the store nor by Tech.
    fiscal: 'bg-purple-100 text-purple-800',
}

// The error card's tone, keyed on WHO resolves it rather than on how alarming it looks. An
// invoice the store has to issue is not the same event as a crash; painting both in the
// same red taught operators to read every card as equally urgent, and so to read none of
// them. Classes are spelled out in full — Tailwind's purge only sees literal strings, so a
// composed class name would be stripped from the build.
export const RESPONSIBLE_AREA_TONE = {
    customer:  { rail: 'bg-yellow-500', tile: 'bg-yellow-100 text-yellow-700', chip: 'bg-yellow-100 text-yellow-800', dot: 'bg-yellow-500', strip: 'bg-yellow-50' },
    lastmile:  { rail: 'bg-orange-500', tile: 'bg-orange-100 text-orange-700', chip: 'bg-orange-100 text-orange-800', dot: 'bg-orange-500', strip: 'bg-orange-50' },
    cubbo_ops: { rail: 'bg-teal-500',   tile: 'bg-teal-100 text-teal-700',     chip: 'bg-teal-100 text-teal-800',     dot: 'bg-teal-500',   strip: 'bg-teal-50' },
    tech:      { rail: 'bg-red-500',    tile: 'bg-red-100 text-red-700',       chip: 'bg-red-100 text-red-800',       dot: 'bg-red-500',    strip: 'bg-red-50' },
    fiscal:    { rail: 'bg-purple-500', tile: 'bg-purple-100 text-purple-700', chip: 'bg-purple-100 text-purple-800', dot: 'bg-purple-500', strip: 'bg-purple-50' },
}

export const DEFAULT_AREA_TONE = {
    rail: 'bg-gray-400', tile: 'bg-gray-100 text-gray-600', chip: 'bg-gray-100 text-gray-700', dot: 'bg-gray-400', strip: 'bg-gray-50',
}

export const CATEGORY_STYLES = {
    LAST_MILE: { bg: 'bg-orange-100', text: 'text-orange-600', icon: 'text-orange-500', pill: 'bg-orange-50 text-orange-700' },
    INVOICING: { bg: 'bg-yellow-100', text: 'text-yellow-700', icon: 'text-yellow-600', pill: 'bg-yellow-50 text-yellow-700' },
    VALIDATION: { bg: 'bg-red-100', text: 'text-red-600', icon: 'text-red-500', pill: 'bg-red-50 text-red-700' },
    AUTHORIZATION: { bg: 'bg-red-100', text: 'text-red-600', icon: 'text-red-500', pill: 'bg-red-50 text-red-700' },
    CONCURRENCY: { bg: 'bg-blue-100', text: 'text-blue-600', icon: 'text-blue-500', pill: 'bg-blue-50 text-blue-700' },
    SYSTEM: { bg: 'bg-red-100', text: 'text-red-600', icon: 'text-red-500', pill: 'bg-red-50 text-red-700' },
}

export const ERROR_STATUS_STYLES = {
    open: 'bg-red-100 text-red-800',
    pending_retry: 'bg-blue-100 text-blue-800',
    retry_failed: 'bg-gray-100 text-gray-600',
    solved: 'bg-green-100 text-green-800',
}
